/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  ConcernStatusDto,
  GetAllConcernStatusesParams,
  IReadOnlyListOfConcernStatusDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all concernstatus enumeration values, with an optional filter.
 */
export const getAllConcernStatuses = (
    params?: GetAllConcernStatusesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfConcernStatusDto>>,) => {
      return customInstance<IReadOnlyListOfConcernStatusDto>(
      {url: `/deployment/concern-statuses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the ConcernStatus identified by the route id.
 */
export const getConcernStatusById = (
    id: number,
 options?: SecondParameter<typeof customInstance<ConcernStatusDto>>,) => {
      return customInstance<ConcernStatusDto>(
      {url: `/deployment/concern-statuses/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllConcernStatusesResult = NonNullable<Awaited<ReturnType<typeof getAllConcernStatuses>>>
export type GetConcernStatusByIdResult = NonNullable<Awaited<ReturnType<typeof getConcernStatusById>>>
